import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'underline',
})

export default class Underline extends Vue {

    // ----------------------------------------------------
    // Properties

    @Prop()
    private content!: any;


    @Prop()
    private showCorrect!: boolean;


    private isPause: boolean = false;

    /*
     * Hold the audio details
     */
    private audioRecorder: any = null;


    private get userAnswer() {
        const content = this.content;
        const userAnswer = content.userAnswer;
        return userAnswer;
    }

    private get question() {
        const question = this.content.resource;
        return question;
    }

    private get baseQuestions() {
        return this.question.answers;
    }

    private get answerObject() {
        return this.content.answerObject;
    }

    private get answers() {
      return this.showCorrect ? this.baseQuestions : this.answerObject;
    }

    private answerIndex: number = 0;

    // ---------------------------------------------------------------
    // Hooks

    private created() {
      if (this.showCorrect) {
        for (
          let index = 0;
          index < this.answers.length;
          index++
        ) {
          const element = this.answers[index];
          if (element.correctAnswer) {
            element.correctAnswer.map((data: any) => {
              this.hightLightDefaultWord(data, index, true);
              return data;
            });
          }
        }
      } else {
        const objectResult = this.answers;
        objectResult.map((result: any, index: number) => {
          result.text.split(',').map((subresult: any) => {
            const answerResult = this.answers[index];
            if (answerResult.correctAnswer.indexOf(subresult) !== -1) {
              this.hightLightDefaultWord(subresult, index, true);
            } else {
              this.hightLightDefaultWord(subresult, index, false);
            }
            return subresult;
          });
        });
      }
    }


    // -----------------------------------------------------------------
    // Actions



    // --------------------------------------------------------------
    // Methods


    private hightLightDefaultWord(text: any, answerIndex: number, status: any) {
      const component = this;
      let innerHTML = '';
      let html = '';
      if (status) {
        html = `<span class="correct">${text}</span>`;
      } else {
        html = `<span class="error">${text}</span>`;
      }
      component
        .$el.querySelectorAll(`.answer-underline .answer-edit-${answerIndex}`)[0]
        .childNodes.forEach((childNode: any) => {
          if (childNode.data) {
            innerHTML = innerHTML + childNode.data.replace(text, html.trim());
          } else if (childNode.data) {
            innerHTML = innerHTML + childNode.data;
          } else {
            innerHTML = innerHTML + childNode.outerHTML;
          }
        });
      (component
        .$el.querySelector(`.answer-underline .answer-edit-${answerIndex}`) as HTMLElement)
        .innerHTML = innerHTML;
    }




}
